module.exports = __webpack_public_path__ + "img/group.0036f047.svg";